import * as React from "react";
import {
  List,
  DataTable,
  BooleanField,
  SearchInput,
  BooleanInput,
  EditButton,
} from "react-admin";

const PlaceTypeFilter = [
  <SearchInput source="name" alwaysOn />,
  <BooleanInput label="Visible" source="visible" />,
  <BooleanInput label="Activo" source="active" />,
];

const PlaceTypeList = () => {
  return (
    <List
      title="Tipos de Lugares"
      filters={PlaceTypeFilter}
      sort={{ field: "order", order: "ASC" }}
    >
      <DataTable rowClick="show" bulkActionButtons={false}>
        <DataTable.Col source="name" label="Nombre" />
        <DataTable.NumberCol source="order" label="Orden" />
        <DataTable.Col source="iconName" label="Nombre de Ícono" />
        <DataTable.Col source="visible" label="Visible">
          <BooleanField source="visible" label="Visible" />
        </DataTable.Col>
        <DataTable.Col source="active" label="Activo">
          <BooleanField source="active" label="Activo" />
        </DataTable.Col>
        <DataTable.Col>
          <EditButton />
        </DataTable.Col>
      </DataTable>
    </List>
  );
};

export default PlaceTypeList;
